var map = {
	"./allinc.png": 1498,
	"./allinclusive.png": 1900,
	"./alpereiser.png": 9517,
	"./amisol.png": 6502,
	"./apollo.png": 6800,
	"./escapeaway.png": 3758,
	"./lionalpin.png": 6401,
	"./loveholidays.png": 4742,
	"./nazar.png": 6973,
	"./norwegianholidays.png": 6708,
	"./solfaktor.png": 9016,
	"./solia.png": 6039,
	"./soliadynamic.png": 2194,
	"./test.png": 4789,
	"./ticket.png": 1301,
	"./tripx.png": 1060,
	"./tui.png": 8745,
	"./ving.png": 7371,
	"./vingdynamic.png": 2486,
	"./vitalreiser.png": 9511,
	"src/static/logo/supplier/66x22/allinc.png": 1498,
	"src/static/logo/supplier/66x22/allinclusive.png": 1900,
	"src/static/logo/supplier/66x22/alpereiser.png": 9517,
	"src/static/logo/supplier/66x22/amisol.png": 6502,
	"src/static/logo/supplier/66x22/apollo.png": 6800,
	"src/static/logo/supplier/66x22/escapeaway.png": 3758,
	"src/static/logo/supplier/66x22/lionalpin.png": 6401,
	"src/static/logo/supplier/66x22/loveholidays.png": 4742,
	"src/static/logo/supplier/66x22/nazar.png": 6973,
	"src/static/logo/supplier/66x22/norwegianholidays.png": 6708,
	"src/static/logo/supplier/66x22/solfaktor.png": 9016,
	"src/static/logo/supplier/66x22/solia.png": 6039,
	"src/static/logo/supplier/66x22/soliadynamic.png": 2194,
	"src/static/logo/supplier/66x22/test.png": 4789,
	"src/static/logo/supplier/66x22/ticket.png": 1301,
	"src/static/logo/supplier/66x22/tripx.png": 1060,
	"src/static/logo/supplier/66x22/tui.png": 8745,
	"src/static/logo/supplier/66x22/ving.png": 7371,
	"src/static/logo/supplier/66x22/vingdynamic.png": 2486,
	"src/static/logo/supplier/66x22/vitalreiser.png": 9511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2596;